/** @format */

import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { HmfCheckboxComponent } from '@dsg-tech/homefield-angular';

@Component({
  selector: 'shared-totf-components-skeleton-product-card',
  templateUrl: './skeleton-product-card.component.html',
  styleUrl: './skeleton-product-card.component.scss',
  imports: [HmfCheckboxComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonProductCardComponent {
  compareCheckboxEnabled = input(false);
  readonly desktopHeight = input(559);
}
